// NFL Schedule
// 2023 Season

// By Week:
// All Weeks
// By Team:
// Schedule Grid  |	Bye Weeks
//   Week 1
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Sep 7	8:20 pm	 Detroit Lions	 Kansas City Chiefs
//  Sun Sep 10	1:00 pm	 Arizona Cardinals	 Washington Commanders
//  	1:00 pm	 Carolina Panthers	 Atlanta Falcons
//  	1:00 pm	 Cincinnati Bengals	 Cleveland Browns
//  	1:00 pm	 Houston Texans	 Baltimore Ravens
//  	1:00 pm	 Jacksonville Jaguars	 Indianapolis Colts
//  	1:00 pm	 San Francisco 49ers	 Pittsburgh Steelers
//  	1:00 pm	 Tampa Bay Buccaneers	 Minnesota Vikings
//  	1:00 pm	 Tennessee Titans	 New Orleans Saints
//  	4:25 pm	 Green Bay Packers	 Chicago Bears
//  	4:25 pm	 Las Vegas Raiders	 Denver Broncos
//  	4:25 pm	 Los Angeles Rams	 Seattle Seahawks
//  	4:25 pm	 Miami Dolphins	 Los Angeles Chargers
//  	4:25 pm	 Philadelphia Eagles	 New England Patriots
//  	8:20 pm	 Dallas Cowboys	 New York Giants
//  Mon Sep 11	8:15 pm	 Buffalo Bills	 New York Jets
//   Week 2
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Sep 14	8:15 pm	 Minnesota Vikings	 Philadelphia Eagles
//  Sun Sep 17	1:00 pm	 Baltimore Ravens	 Cincinnati Bengals
//  	1:00 pm	 Chicago Bears	 Tampa Bay Buccaneers
//  	1:00 pm	 Green Bay Packers	 Atlanta Falcons
//  	1:00 pm	 Indianapolis Colts	 Houston Texans
//  	1:00 pm	 Kansas City Chiefs	 Jacksonville Jaguars
//  	1:00 pm	 Las Vegas Raiders	 Buffalo Bills
//  	1:00 pm	 Los Angeles Chargers	 Tennessee Titans
//  	1:00 pm	 Seattle Seahawks	 Detroit Lions
//  	4:05 pm	 New York Giants	 Arizona Cardinals
//  	4:05 pm	 San Francisco 49ers	 Los Angeles Rams
//  	4:25 pm	 New York Jets	 Dallas Cowboys
//  	4:25 pm	 Washington Commanders	 Denver Broncos
//  	8:20 pm	 Miami Dolphins	 New England Patriots
//  Mon Sep 18	7:15 pm	 New Orleans Saints	 Carolina Panthers
//  	8:15 pm	 Cleveland Browns	 Pittsburgh Steelers
//   Week 3
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Sep 21	8:15 pm	 New York Giants	 San Francisco 49ers
//  Sun Sep 24	1:00 pm	 Atlanta Falcons	 Detroit Lions
//  	1:00 pm	 Buffalo Bills	 Washington Commanders
//  	1:00 pm	 Denver Broncos	 Miami Dolphins
//  	1:00 pm	 Houston Texans	 Jacksonville Jaguars
//  	1:00 pm	 Los Angeles Chargers	 Minnesota Vikings
//  	1:00 pm	 New England Patriots	 New York Jets
//  	1:00 pm	 New Orleans Saints	 Green Bay Packers
//  	1:00 pm	 Tennessee Titans	 Cleveland Browns
//  	4:05 pm	 Carolina Panthers	 Seattle Seahawks
//  	4:05 pm	 Indianapolis Colts	 Baltimore Ravens
//  	4:25 pm	 Chicago Bears	 Kansas City Chiefs
//  	4:25 pm	 Dallas Cowboys	 Arizona Cardinals
//  	8:20 pm	 Pittsburgh Steelers	 Las Vegas Raiders
//  Mon Sep 25	7:15 pm	 Philadelphia Eagles	 Tampa Bay Buccaneers
//  	8:15 pm	 Los Angeles Rams	 Cincinnati Bengals
//   Week 4
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Sep 28	8:15 pm	 Detroit Lions	 Green Bay Packers
//  Sun Oct 1	9:30 am	 Atlanta Falcons	 Jacksonville Jaguars ¹
//  	1:00 pm	 Baltimore Ravens	 Cleveland Browns
//  	1:00 pm	 Cincinnati Bengals	 Tennessee Titans
//  	1:00 pm	 Denver Broncos	 Chicago Bears
//  	1:00 pm	 Los Angeles Rams	 Indianapolis Colts
//  	1:00 pm	 Miami Dolphins	 Buffalo Bills
//  	1:00 pm	 Minnesota Vikings	 Carolina Panthers
//  	1:00 pm	 Pittsburgh Steelers	 Houston Texans
//  	1:00 pm	 Tampa Bay Buccaneers	 New Orleans Saints
//  	1:00 pm	 Washington Commanders	 Philadelphia Eagles
//  	4:05 pm	 Las Vegas Raiders	 Los Angeles Chargers
//  	4:25 pm	 Arizona Cardinals	 San Francisco 49ers
//  	4:25 pm	 New England Patriots	 Dallas Cowboys
//  	8:20 pm	 Kansas City Chiefs	 New York Jets
//  Mon Oct 2	8:15 pm	 Seattle Seahawks	 New York Giants

//  ¹ This game is being played in London.

//   Week 5
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Oct 5	8:15 pm	 Chicago Bears	 Washington Commanders
//  Sun Oct 8	9:30 am	 Jacksonville Jaguars	 Buffalo Bills ¹
//  	1:00 pm	 Baltimore Ravens	 Pittsburgh Steelers
//  	1:00 pm	 Carolina Panthers	 Detroit Lions
//  	1:00 pm	 Houston Texans	 Atlanta Falcons
//  	1:00 pm	 New Orleans Saints	 New England Patriots
//  	1:00 pm	 New York Giants	 Miami Dolphins
//  	1:00 pm	 Tennessee Titans	 Indianapolis Colts
//  	4:05 pm	 Cincinnati Bengals	 Arizona Cardinals
//  	4:05 pm	 Philadelphia Eagles	 Los Angeles Rams
//  	4:25 pm	 Kansas City Chiefs	 Minnesota Vikings
//  	4:25 pm	 New York Jets	 Denver Broncos
//  	8:20 pm	 Dallas Cowboys	 San Francisco 49ers
//  Mon Oct 9	8:15 pm	 Green Bay Packers	 Las Vegas Raiders

//  ¹ This game is being played in London.

//  Bye: Cleveland, L.A. Chargers, Seattle, Tampa Bay

//   Week 6
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Oct 12	8:15 pm	 Denver Broncos	 Kansas City Chiefs
//  Sun Oct 15	9:30 am	 Baltimore Ravens	 Tennessee Titans ¹
//  	1:00 pm	 Carolina Panthers	 Miami Dolphins
//  	1:00 pm	 Indianapolis Colts	 Jacksonville Jaguars
//  	1:00 pm	 Minnesota Vikings	 Chicago Bears
//  	1:00 pm	 New Orleans Saints	 Houston Texans
//  	1:00 pm	 San Francisco 49ers	 Cleveland Browns
//  	1:00 pm	 Seattle Seahawks	 Cincinnati Bengals
//  	1:00 pm	 Washington Commanders	 Atlanta Falcons
//  	4:05 pm	 New England Patriots	 Las Vegas Raiders
//  	4:25 pm	 Arizona Cardinals	 Los Angeles Rams
//  	4:25 pm	 Detroit Lions	 Tampa Bay Buccaneers
//  	4:25 pm	 Philadelphia Eagles	 New York Jets
//  	8:20 pm	 New York Giants	 Buffalo Bills
//  Mon Oct 16	8:15 pm	 Dallas Cowboys	 Los Angeles Chargers

//  ¹ This game is being played in London.

//  Bye: Green Bay, Pittsburgh

//   Week 7
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Oct 19	8:15 pm	 Jacksonville Jaguars	 New Orleans Saints
//  Sun Oct 22	1:00 pm	 Atlanta Falcons	 Tampa Bay Buccaneers
//  	1:00 pm	 Buffalo Bills	 New England Patriots
//  	1:00 pm	 Cleveland Browns	 Indianapolis Colts
//  	1:00 pm	 Detroit Lions	 Baltimore Ravens
//  	1:00 pm	 Las Vegas Raiders	 Chicago Bears
//  	1:00 pm	 Washington Commanders	 New York Giants
//  	4:05 pm	 Arizona Cardinals	 Seattle Seahawks
//  	4:05 pm	 Pittsburgh Steelers	 Los Angeles Rams
//  	4:25 pm	 Green Bay Packers	 Denver Broncos
//  	4:25 pm	 Los Angeles Chargers	 Kansas City Chiefs
//  	8:20 pm	 Miami Dolphins	 Philadelphia Eagles
//  Mon Oct 23	8:15 pm	 San Francisco 49ers	 Minnesota Vikings

//  Bye: Carolina, Cincinnati, Dallas, Houston, N.Y. Jets, Tennessee

//   Week 8
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Oct 26	8:15 pm	 Tampa Bay Buccaneers	 Buffalo Bills
//  Sun Oct 29	1:00 pm	 Atlanta Falcons	 Tennessee Titans
//  	1:00 pm	 Houston Texans	 Carolina Panthers
//  	1:00 pm	 Jacksonville Jaguars	 Pittsburgh Steelers
//  	1:00 pm	 Los Angeles Rams	 Dallas Cowboys
//  	1:00 pm	 Minnesota Vikings	 Green Bay Packers
//  	1:00 pm	 New England Patriots	 Miami Dolphins
//  	1:00 pm	 New Orleans Saints	 Indianapolis Colts
//  	1:00 pm	 New York Jets	 New York Giants
//  	1:00 pm	 Philadelphia Eagles	 Washington Commanders
//  	4:05 pm	 Cleveland Browns	 Seattle Seahawks
//  	4:25 pm	 Baltimore Ravens	 Arizona Cardinals
//  	4:25 pm	 Cincinnati Bengals	 San Francisco 49ers
//  	4:25 pm	 Kansas City Chiefs	 Denver Broncos
//  	8:20 pm	 Chicago Bears	 Los Angeles Chargers
//  Mon Oct 30	8:15 pm	 Las Vegas Raiders	 Detroit Lions
//   Week 9
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Nov 2	8:15 pm	 Tennessee Titans	 Pittsburgh Steelers
//  Sun Nov 5	9:30 am	 Miami Dolphins	 Kansas City Chiefs ¹
//  	1:00 pm	 Arizona Cardinals	 Cleveland Browns
//  	1:00 pm	 Chicago Bears	 New Orleans Saints
//  	1:00 pm	 Los Angeles Rams	 Green Bay Packers
//  	1:00 pm	 Minnesota Vikings	 Atlanta Falcons
//  	1:00 pm	 Seattle Seahawks	 Baltimore Ravens
//  	1:00 pm	 Tampa Bay Buccaneers	 Houston Texans
//  	1:00 pm	 Washington Commanders	 New England Patriots
//  	4:05 pm	 Indianapolis Colts	 Carolina Panthers
//  	4:25 pm	 Dallas Cowboys	 Philadelphia Eagles
//  	4:25 pm	 New York Giants	 Las Vegas Raiders
//  	8:20 pm	 Buffalo Bills	 Cincinnati Bengals
//  Mon Nov 6	8:15 pm	 Los Angeles Chargers	 New York Jets

//  ¹ This game is being played in Frankfurt.

//  Bye: Denver, Detroit, Jacksonville, San Francisco

//   Week 10
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Nov 9	8:15 pm	 Carolina Panthers	 Chicago Bears
//  Sun Nov 12	9:30 am	 Indianapolis Colts	 New England Patriots ¹
//  	1:00 pm	 Cleveland Browns	 Baltimore Ravens
//  	1:00 pm	 Green Bay Packers	 Pittsburgh Steelers
//  	1:00 pm	 Houston Texans	 Cincinnati Bengals
//  	1:00 pm	 New Orleans Saints	 Minnesota Vikings
//  	1:00 pm	 San Francisco 49ers	 Jacksonville Jaguars
//  	1:00 pm	 Tennessee Titans	 Tampa Bay Buccaneers
//  	4:05 pm	 Atlanta Falcons	 Arizona Cardinals
//  	4:05 pm	 Detroit Lions	 Los Angeles Chargers
//  	4:25 pm	 New York Giants	 Dallas Cowboys
//  	4:25 pm	 Washington Commanders	 Seattle Seahawks
//  	8:20 pm	 New York Jets	 Las Vegas Raiders
//  Mon Nov 13	8:15 pm	 Denver Broncos	 Buffalo Bills

//  ¹ This game is being played in Frankfurt.

//  Bye: Kansas City, L.A. Rams, Miami, Philadelphia

//   Week 11
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Nov 16	8:15 pm	 Cincinnati Bengals	 Baltimore Ravens
//  Sun Nov 19	1:00 pm	 Arizona Cardinals	 Houston Texans
//  	1:00 pm	 Chicago Bears	 Detroit Lions
//  	1:00 pm	 Dallas Cowboys	 Carolina Panthers
//  	1:00 pm	 Las Vegas Raiders	 Miami Dolphins
//  	1:00 pm	 Los Angeles Chargers	 Green Bay Packers
//  	1:00 pm	 New York Giants	 Washington Commanders
//  	1:00 pm	 Pittsburgh Steelers	 Cleveland Browns
//  	1:00 pm	 Tennessee Titans	 Jacksonville Jaguars
//  	4:05 pm	 Tampa Bay Buccaneers	 San Francisco 49ers
//  	4:25 pm	 New York Jets	 Buffalo Bills
//  	4:25 pm	 Seattle Seahawks	 Los Angeles Rams
//  	8:20 pm	 Minnesota Vikings	 Denver Broncos
//  Mon Nov 20	8:15 pm	 Philadelphia Eagles	 Kansas City Chiefs

//  Bye: Atlanta, Indianapolis, New England, New Orleans

//   Week 12
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Nov 23	12:30 pm	 Green Bay Packers	 Detroit Lions
//  	4:30 pm	 Washington Commanders	 Dallas Cowboys
//  	8:20 pm	 San Francisco 49ers	 Seattle Seahawks
//  Fri Nov 24	3:00 pm	 Miami Dolphins	 New York Jets
//  Sun Nov 26	1:00 pm	 Carolina Panthers	 Tennessee Titans
//  	1:00 pm	 Jacksonville Jaguars	 Houston Texans
//  	1:00 pm	 New England Patriots	 New York Giants
//  	1:00 pm	 New Orleans Saints	 Atlanta Falcons
//  	1:00 pm	 Pittsburgh Steelers	 Cincinnati Bengals
//  	1:00 pm	 Tampa Bay Buccaneers	 Indianapolis Colts
//  	4:05 pm	 Cleveland Browns	 Denver Broncos
//  	4:05 pm	 Los Angeles Rams	 Arizona Cardinals
//  	4:25 pm	 Buffalo Bills	 Philadelphia Eagles
//  	4:25 pm	 Kansas City Chiefs	 Las Vegas Raiders
//  	8:20 pm	 Baltimore Ravens	 Los Angeles Chargers
//  Mon Nov 27	8:15 pm	 Chicago Bears	 Minnesota Vikings
//   Week 13
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Nov 30	8:15 pm	 Seattle Seahawks	 Dallas Cowboys
//  Sun Dec 3	1:00 pm	 Arizona Cardinals	 Pittsburgh Steelers
//  	1:00 pm	 Atlanta Falcons	 New York Jets
//  	1:00 pm	 Carolina Panthers	 Tampa Bay Buccaneers
//  	1:00 pm	 Detroit Lions	 New Orleans Saints
//  	1:00 pm	 Indianapolis Colts	 Tennessee Titans
//  	1:00 pm	 Los Angeles Chargers	 New England Patriots
//  	1:00 pm	 Miami Dolphins	 Washington Commanders
//  	4:05 pm	 Denver Broncos	 Houston Texans
//  	4:25 pm	 Cleveland Browns	 Los Angeles Rams
//  	4:25 pm	 San Francisco 49ers	 Philadelphia Eagles
//  	8:20 pm	 Kansas City Chiefs	 Green Bay Packers
//  Mon Dec 4	8:15 pm	 Cincinnati Bengals	 Jacksonville Jaguars

//  Bye: Baltimore, Buffalo, Chicago, Las Vegas, Minnesota, N.Y. Giants

//   Week 14
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Dec 7	8:15 pm	 New England Patriots	 Pittsburgh Steelers
//  Sun Dec 10	1:00 pm	 Carolina Panthers	 New Orleans Saints
//  	1:00 pm	 Detroit Lions	 Chicago Bears
//  	1:00 pm	 Houston Texans	 New York Jets
//  	1:00 pm	 Indianapolis Colts	 Cincinnati Bengals
//  	1:00 pm	 Jacksonville Jaguars	 Cleveland Browns
//  	1:00 pm	 Los Angeles Rams	 Baltimore Ravens
//  	1:00 pm	 Tampa Bay Buccaneers	 Atlanta Falcons
//  	4:05 pm	 Minnesota Vikings	 Las Vegas Raiders
//  	4:05 pm	 Seattle Seahawks	 San Francisco 49ers
//  	4:25 pm	 Buffalo Bills	 Kansas City Chiefs
//  	4:25 pm	 Denver Broncos	 Los Angeles Chargers
//  	8:20 pm	 Philadelphia Eagles	 Dallas Cowboys
//  Mon Dec 11	8:15 pm	 Green Bay Packers	 New York Giants
//  	8:15 pm	 Tennessee Titans	 Miami Dolphins

//  Bye: Arizona, Washington

//   Week 15
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Dec 14	8:15 pm	 Los Angeles Chargers	 Las Vegas Raiders
//  Sun Dec 17	1:00 pm	 Atlanta Falcons	 Carolina Panthers
//  	1:00 pm	 Chicago Bears	 Cleveland Browns
//  	1:00 pm	 Denver Broncos	 Detroit Lions
//  	1:00 pm	 Houston Texans	 Tennessee Titans
//  	1:00 pm	 Minnesota Vikings	 Cincinnati Bengals
//  	1:00 pm	 New York Giants	 New Orleans Saints
//  	1:00 pm	 New York Jets	 Miami Dolphins
//  	1:00 pm	 Pittsburgh Steelers	 Indianapolis Colts
//  	1:00 pm	 Tampa Bay Buccaneers	 Green Bay Packers
//  	4:05 pm	 San Francisco 49ers	 Arizona Cardinals
//  	4:05 pm	 Washington Commanders	 Los Angeles Rams
//  	4:25 pm	 Dallas Cowboys	 Buffalo Bills
//  	4:25 pm	 Philadelphia Eagles	 Seattle Seahawks
//  	8:20 pm	 Baltimore Ravens	 Jacksonville Jaguars
//  Mon Dec 18	8:15 pm	 Kansas City Chiefs	 New England Patriots
//   Week 16
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Dec 21	8:15 pm	 New Orleans Saints	 Los Angeles Rams
//  Sat Dec 23	4:30 pm	 Cincinnati Bengals	 Pittsburgh Steelers
//  	8:00 pm	 Buffalo Bills	 Los Angeles Chargers
//  Sun Dec 24	1:00 pm	 Cleveland Browns	 Houston Texans
//  	1:00 pm	 Detroit Lions	 Minnesota Vikings
//  	1:00 pm	 Green Bay Packers	 Carolina Panthers
//  	1:00 pm	 Indianapolis Colts	 Atlanta Falcons
//  	1:00 pm	 Seattle Seahawks	 Tennessee Titans
//  	1:00 pm	 Washington Commanders	 New York Jets
//  	4:05 pm	 Jacksonville Jaguars	 Tampa Bay Buccaneers
//  	4:25 pm	 Arizona Cardinals	 Chicago Bears
//  	4:25 pm	 Dallas Cowboys	 Miami Dolphins
//  	8:15 pm	 New England Patriots	 Denver Broncos
//  Mon Dec 25	1:00 pm	 Las Vegas Raiders	 Kansas City Chiefs
//  	4:30 pm	 New York Giants	 Philadelphia Eagles
//  	8:15 pm	 Baltimore Ravens	 San Francisco 49ers
//   Week 17
//  Date	Time (ET)	 Away Team	 Home Team
//  Thu Dec 28	8:15 pm	 New York Jets	 Cleveland Browns
//  Sat Dec 30	8:15 pm	 Detroit Lions	 Dallas Cowboys
//  Sun Dec 31	1:00 pm	 Arizona Cardinals	 Philadelphia Eagles
//  	1:00 pm	 Atlanta Falcons	 Chicago Bears
//  	1:00 pm	 Carolina Panthers	 Jacksonville Jaguars
//  	1:00 pm	 Las Vegas Raiders	 Indianapolis Colts
//  	1:00 pm	 Los Angeles Rams	 New York Giants
//  	1:00 pm	 Miami Dolphins	 Baltimore Ravens
//  	1:00 pm	 New England Patriots	 Buffalo Bills
//  	1:00 pm	 New Orleans Saints	 Tampa Bay Buccaneers
//  	1:00 pm	 San Francisco 49ers	 Washington Commanders
//  	1:00 pm	 Tennessee Titans	 Houston Texans
//  	4:05 pm	 Pittsburgh Steelers	 Seattle Seahawks
//  	4:25 pm	 Cincinnati Bengals	 Kansas City Chiefs
//  	4:25 pm	 Los Angeles Chargers	 Denver Broncos
//  	8:20 pm	 Green Bay Packers	 Minnesota Vikings
//   Week 18
//  Date	Time (ET)	 Away Team	 Home Team
//  Sun Jan 7	1:00 pm	 Atlanta Falcons	 New Orleans Saints
//  	1:00 pm	 Buffalo Bills	 Miami Dolphins
//  	1:00 pm	 Chicago Bears	 Green Bay Packers
//  	1:00 pm	 Cleveland Browns	 Cincinnati Bengals
//  	1:00 pm	 Dallas Cowboys	 Washington Commanders
//  	1:00 pm	 Denver Broncos	 Las Vegas Raiders
//  	1:00 pm	 Houston Texans	 Indianapolis Colts
//  	1:00 pm	 Jacksonville Jaguars	 Tennessee Titans
//  	1:00 pm	 Kansas City Chiefs	 Los Angeles Chargers
//  	1:00 pm	 Los Angeles Rams	 San Francisco 49ers
//  	1:00 pm	 Minnesota Vikings	 Detroit Lions
//  	1:00 pm	 New York Jets	 New England Patriots
//  	1:00 pm	 Philadelphia Eagles	 New York Giants
//  	1:00 pm	 Pittsburgh Steelers	 Baltimore Ravens
//  	1:00 pm	 Seattle Seahawks	 Arizona Cardinals
//  	1:00 pm	 Tampa Bay Buccaneers	 Carolina Panthers

export const schedules = [
  {
    id: 1,
    week: 1,
    date: "Thu, Sep 7, 2023",
    time: "8:20p",
    home: "Kansas City Chiefs",
    away: "Detroit Lions",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
  },
  {
    id: 2,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Atlanta Falcons",
    away: "Carolina Panthers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
  },
  {
    id: 3,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Baltimore Ravens",
    away: "Houston Texans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 4,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Cleveland Browns",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 5,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Indianapolis Colts",
    away: "Jacksonville Jaguars",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
  },
  {
    id: 6,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Minnesota Vikings",
    away: "Tampa Bay Buccaneers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
  },
  {
    id: 7,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "New Orleans Saints",
    away: "Tennessee Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 8,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Pittsburgh Steelers",
    away: "San Francisco 49ers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
  },
  {
    id: 9,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "1:00p",
    home: "Washington Commanders",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 10,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "4:25p",
    home: "Chicago Bears",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 11,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "4:25p (ET)",
    home: "Denver Broncos",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 12,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "4:25p (ET)",
    home: "Los Angeles Chargers",
    away: "Miami Dolphins",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
  },
  {
    id: 13,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "4:25p (ET)",
    home: "New England Patriots",
    away: "Philadelphia Eagles",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
  },
  {
    id: 14,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "4:25p (ET)",
    home: "Seattle Seahawks",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
  },
  {
    id: 15,
    week: 1,
    date: "Sun, Sep 10, 2023",
    time: "8:20p (ET)",
    home: "New York Giants",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 16,
    week: 1,
    date: "Mon, Sep 11, 2023",
    time: "8:15p (ET)",
    home: "New York Jets",
    away: "Buffalo Bills",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
  },
  {
    id: 17,
    week: 2,
    date: "Thu, Sep 14, 2023",
    time: "8:20p (ET)",
    home: "Philadelphia Eagles",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 18,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Atlanta Falcons",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 19,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Buffalo Bills",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 20,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Baltimore Ravens",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 21,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Tampa Bay Buccaneers",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 22,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Atlanta Falcons",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 23,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Houston Texans",
    away: "Indianapolis Colts",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
  },
  {
    id: 24,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Jacksonville Jaguars",
    away: "Kansas City Chiefs",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
  },
  {
    id: 25,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Buffalo Bills",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 26,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Tennessee Titans",
    away: "Los Angeles Chargers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
  },
  {
    id: 27,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "1:00p (ET)",
    home: "Detroit Lions",
    away: "Seattle Seahawks",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
  },
  {
    id: 28,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "4:05 (ET)",
    home: "Arizona Cardinals",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 29,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "4:05 (ET)",
    home: "Los Angeles Rams",
    away: "San Francisco 49ers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
  },
  {
    id: 30,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "4:25 (ET)",
    home: "Dallas Cowboys",
    away: "New York Jets",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
  },
  {
    id: 31,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "4:25 (ET)",
    home: "Denver Broncos",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 32,
    week: 2,
    date: "Sun, Sep 17, 2023",
    time: "8:20 (ET)",
    home: "New England Patriots",
    away: "Miami Dolphins",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
  },
  {
    id: 33,
    week: 2,
    date: "Mon, Sep 18, 2023",
    time: "7:15 (ET)",
    home: "Carolina Panthers",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 34,
    week: 2,
    date: "Mon, Sep 18, 2023",
    time: "8:15 (ET)",
    home: "Pittsburgh Steelers",
    away: "Cleveland Browns",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
  },
  {
    id: 35,
    week: 3,
    date: "Thu, Sep 21, 2023",
    time: "8:15 (ET)",
    home: "San Francisco 49ers",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 36,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Detroit Lions",
    away: "Atlanta Falcons",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
  },
  {
    id: 37,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Washington Commanders",
    away: "Buffalo Bills",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
  },
  {
    id: 38,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Miami Dolphins",
    away: "Denver Broncos",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
  },
  {
    id: 39,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Jacksonville Jaguars",
    away: "Houston Texans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 40,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Minnesota Vikings",
    away: "Los Angeles Chargers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
  },
  {
    id: 41,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "New York Jets",
    away: "New England Patriots",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
  },
  {
    id: 42,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Green Bay Packers",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 43,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "1:00 (ET)",
    home: "Cleveland Browns",
    away: "Tennessee Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 44,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "4:05 (ET)",
    home: "Seattle Seahawks",
    away: "Carolina Panthers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
  },
  {
    id: 45,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "4:05 (ET)",
    home: "Baltimore Ravens",
    away: "Indianapolis Colts",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
  },
  {
    id: 46,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "4:25 (ET)",
    home: "Kansas City Chiefs",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 47,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "4:25 (ET)",
    home: "Arizona Cardinals",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 48,
    week: 3,
    date: "Sun, Sep 24, 2023",
    time: "8:20 (ET)",
    home: "Las Vegas Raiders",
    away: "Pittsburgh Steelers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
  },
  {
    id: 49,
    week: 3,
    date: "Mon, Sep 25, 2023",
    time: "7:15 (ET)",
    home: "Tampa Bay Buccaneers",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
  },
  {
    id: 50,
    week: 3,
    date: "Mon, Sep 25, 2023",
    time: "8:15 (ET)",
    home: "Cincinnati Bengals",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
  },
  {
    id: 51,
    week: 4,
    date: "Thu, Sep 28, 2023",
    time: "8:15 (ET)",
    home: "Green Bay Packers",
    away: "Detroit Lions",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
  },
  {
    id: 52,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "9:30 (ET)",
    home: "Jacksonville Jaguars",
    away: "Atlanta Falcons",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
  },
  {
    id: 53,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Cleveland Browns",
    away: "Baltimore Ravens",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
  },
  {
    id: 54,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Tennessee Titans",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 55,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Chicago Bears",
    away: "Denver Broncos",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
  },
  {
    id: 56,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Indianapolis Colts",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
  },
  {
    id: 57,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Buffalo Bills",
    away: "Miami Dolphins",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
  },
  {
    id: 58,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Carolina Panthers",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 59,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Houston Texans",
    away: "Pittsburgh Steelers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
  },
  {
    id: 60,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "New Orleans Saints",
    away: "Tampa Bay Buccaneers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
  },
  {
    id: 61,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "1:00 (ET)",
    home: "Philadelphia Eagles",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 62,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "4:05 (ET)",
    home: "Los Angeles Chargers",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 63,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "4:25 (ET)",
    home: "San Francisco 49ers",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 64,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "4:25 (ET)",
    home: "Dallas Cowboys",
    away: "New England Patriots",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
  },
  {
    id: 65,
    week: 4,
    date: "Sun, Oct 1, 2023",
    time: "8:20 (ET)",
    home: "New York Jets",
    away: "Kansas City Chiefs",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
  },
  {
    id: 66,
    week: 4,
    date: "Mon, Oct 2, 2023",
    time: "8:15 (ET)",
    home: "New York Giants",
    away: "Seattle Seahawks",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
  },
  {
    id: 67,
    week: 5,
    date: "Thu, Oct 5, 2023",
    time: "8:15 (ET)",
    home: "Washington Commanders",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 68,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "9:30 (ET)",
    home: "Buffalo Bills",
    away: "Jacksonville Jaguars",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
  },
  {
    id: 69,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "Pittsburgh Steelers",
    away: "Baltimore Ravens",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
  },
  {
    id: 70,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "Detroit Lions",
    away: "Carolina Panthers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
  },
  {
    id: 71,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "Atlanta Falcons",
    away: "Houston Texans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 72,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "New England Patriots",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 73,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "Miami Dolphins",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 74,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "1:00 (ET)",
    home: "Indianapolis Colts",
    away: "Tennessee Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 75,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "4:05 (ET)",
    home: "Arizona Cardinals",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 76,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "4:05 (ET)",
    home: "Los Angeles Rams",
    away: "Philadelphia Eagles",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
  },
  {
    id: 77,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "4:25 (ET)",
    home: "Minnesota Vikings",
    away: "Kansas City Chiefs",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
  },
  {
    id: 78,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "4:25 (ET)",
    home: "Denver Broncos",
    away: "New York Jets",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
  },
  {
    id: 79,
    week: 5,
    date: "Sun, Oct 8, 2023",
    time: "8:20 (ET)",
    home: "San Francisco 49ers",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 80,
    week: 5,
    date: "Mon, Oct 9, 2023",
    time: "8:15 (ET)",
    home: "Las Vegas Raiders",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 81,
    week: 6,
    date: "Thu, Oct 12, 2023",
    time: "8:15 (ET)",
    home: "Kansas City Chiefs",
    away: "Denver Broncos",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
  },
  {
    id: 82,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "9:30 (ET)",
    home: "Tennessee Titans",
    away: "Baltimore Ravens",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
  },
  {
    id: 83,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Miami Dolphins",
    away: "Carolina Panthers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
  },
  {
    id: 84,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Jacksonville Jaguars",
    away: "Indianapolis Colts",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
  },
  {
    id: 85,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Chicago Bears",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 86,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Houston Texans",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 87,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Cleveland Browns",
    away: "San Francisco 49ers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
  },
  {
    id: 88,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Cincinnati Bengals",
    away: "Seattle Seahawks",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
  },
  {
    id: 89,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "1:00 (ET)",
    home: "Atlanta Falcons",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 90,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "4:05 (ET)",
    home: "Las Vegas Raiders",
    away: "New England Patriots",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
  },
  {
    id: 91,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "4:25 (ET)",
    home: "Los Angeles Rams",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 92,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "4:25 (ET)",
    home: "Tampa Bay Buccaneers",
    away: "Detroit Lions",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
  },
  {
    id: 93,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "4:25 (ET)",
    home: "New York Jets",
    away: "Philadelphia Eagles",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
  },
  {
    id: 94,
    week: 6,
    date: "Sun, Oct 15, 2023",
    time: "8:20 (ET)",
    home: "Buffalo Bills",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 95,
    week: 6,
    date: "Mon, Oct 16, 2023",
    time: "8:15 (ET)",
    home: "Los Angeles Chargers",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 96,
    week: 7,
    date: "Thu, Oct 19, 2023",
    time: "8:15 (ET)",
    home: "New Orleans Saints",
    away: "Jacksonville Jaguars",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
  },
  {
    id: 97,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "Tampa Bay Buccaneers",
    away: "Atlanta Falcons",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
  },
  {
    id: 98,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "New England Patriots",
    away: "Buffalo Bills",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
  },
  {
    id: 99,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "Indianapolis Colts",
    away: "Cleveland Browns",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
  },
  {
    id: 100,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "Baltimore Ravens",
    away: "Detroit Lions",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
  },
  {
    id: 101,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "Chicago Bears",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 102,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "1:00 (ET)",
    home: "New York Giants",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 103,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "4:05 (ET)",
    home: "Seattle Seahawks",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 104,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "4:05 (ET)",
    home: "Los Angeles Rams",
    away: "Pittsburgh Steelers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
  },
  {
    id: 105,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "4:25 (ET)",
    home: "Denver Broncos",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 106,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "4:25 (ET)",
    home: "Kansas City Chiefs",
    away: "Los Angeles Chargers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
  },
  {
    id: 107,
    week: 7,
    date: "Sun, Oct 22, 2023",
    time: "8:20 (ET)",
    home: "Philadelphia Eagles",
    away: "Miami Dolphins",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
  },
  {
    id: 108,
    week: 7,
    date: "Mon, Oct 23, 2023",
    time: "8:15 (ET)",
    home: "Minnesota Vikings",
    away: "San Francisco 49ers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
  },
  {
    id: 109,
    week: 8,
    date: "Thu, Oct 26, 2023",
    time: "8:15 (ET)",
    home: "Buffalo Bills",
    away: "Tampa Bay Buccaneers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
  },
  {
    id: 110,
    week: 8,
    date: "sun, Oct 29, 2023",
    time: "9:30 (ET)",
    home: "Carolina Panthers",
    away: "Houston Texans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 111,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "8:15 (ET)",
    home: "Dallas Cowboys",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
  },
  {
    id: 112,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "8:15 (ET)",
    home: "Green Bay Packers",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 113,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "1:00 (ET)",
    home: "Indianapolis Colts",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 114,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "1:00 (ET)",
    home: "Miami Dolphins",
    away: "New England Patriots",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
  },
  {
    id: 115,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "1:00 (ET)",
    home: "New York Giants",
    away: "New York Jets",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
  },
  {
    id: 116,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "1:00 (ET)",
    home: "Pittsburgh Steelers",
    away: "Jacksonville Jaguars",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
  },
  {
    id: 117,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "1:00 (ET)",
    home: "Tennessee Titans",
    away: "Atlanta Falcons",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
  },
  {
    id: 118,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "4:05 (ET)",
    home: "Washington Commanders",
    away: "Philadelphia Eagles",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
  },
  {
    id: 119,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "4:05 (ET)",
    home: "Seattle Seahawks",
    away: "Cleveland Browns",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
  },
  {
    id: 120,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "4:25 (ET)",
    home: "Arizona Cardinals",
    away: "Baltimore Ravens",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
  },
  {
    id: 121,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "4:25 (ET)",
    home: "Denver Broncos",
    away: "Kansas City Chiefs",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
  },
  {
    id: 122,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "8:20 (ET)",
    home: "San Francisco 49ers",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 123,
    week: 8,
    date: "Sun, Oct 29, 2023",
    time: "8:15 (ET)",
    home: "San Diego Chargers",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 124,
    week: 8,
    date: "Mon, Oct 30, 2023",
    time: "8:15 (ET)",
    home: "Detroit Lions",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 125,
    week: 9,
    date: "Thu, Nov 2, 2023",
    time: "8:15 (ET)",
    home: "Pittsburgh Steelers",
    away: "Texas Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 126,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "9:30 (ET)",
    home: "Kansas City Chiefs",
    away: "Miami Dolphins",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
  },
  {
    id: 127,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "Atlanta Falcons",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 128,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "Baltimore Ravens",
    away: "Seattle Seahawks",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
  },
  {
    id: 129,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "Cleveland Browns",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 130,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "Green Bay Packers",
    away: "Los Angeles Rams",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
  },
  {
    id: 131,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "Houston Texans",
    away: "Tampa Bay Buccaneers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 132,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "1:00 (ET)",
    home: "New England Patriots",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 133,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "4:05 (ET)",
    home: "New Orleans Saints",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 134,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "4:05 (ET)",
    home: "Carolina Panthers",
    away: "Indianapolis Colts",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
  },
  {
    id: 135,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "4:25 (ET)",
    home: "Las Vegas Raiders",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 136,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "4:25 (ET)",
    home: "Philadelphia Eagles",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 137,
    week: 9,
    date: "Sun, Nov 5, 2023",
    time: "8:20 (ET)",
    home: "Cincinnati Bengals",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 138,
    week: 9,
    date: "Mon, Nov 6, 2023",
    time: "8:15 (ET)",
    home: "New York Jets",
    away: "Los Angeles Chargers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
  },
  {
    id: 139,
    week: 10,
    date: "Thu, Nov 9, 2023",
    time: "8:15 (ET)",
    home: "Chicago Bears",
    away: "Carolina Panthers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
  },
  {
    id: 140,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "9:30 (ET)",
    home: "New England Patriots",
    away: "Indianapolis Colts",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/NE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/IND",
  },
  {
    id: 141,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Baltimore Ravens",
    away: "Cleveland Browns",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
  },
  {
    id: 142,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Cincinnati Bengals",
    away: "Houston Texans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
  },
  {
    id: 143,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Jacksonville Jaguars",
    away: "San Francisco 49ers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
  },
  {
    id: 144,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Minnesota Vikings",
    away: "New Orleans Saints",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NO",
  },
  {
    id: 145,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Pittsburgh Steelers",
    away: "Green Bay Packers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
  },
  {
    id: 146,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "1:00 (ET)",
    home: "Tampa Bay Buccaneers",
    away: "Tennessee Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 147,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "4:05 (ET)",
    home: "Arizona Cardinals",
    away: "Atlanta Falcons",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ATL",
  },
  {
    id: 148,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "4:05 (ET)",
    home: "Los Angeles Chargers",
    away: "Detroit Lions",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
  },
  {
    id: 149,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "4:25 (ET)",
    home: "Dallas Cowboys",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 150,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "4:25 (ET)",
    home: "Seattle Seahawks",
    away: "Washington Commanders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
  },
  {
    id: 151,
    week: 10,
    date: "Sun, Nov 12, 2023",
    time: "8:20 (ET)",
    home: "Las Vegas Raiders",
    away: "New York Jets",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
  },
  {
    id: 152,
    week: 10,
    date: "Mon, Nov 13, 2023",
    time: "8:15 (ET)",
    home: "Buffalo Bills",
    away: "Denver Broncos",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
  },
  {
    id: 153,
    week: 11,
    date: "Thu, Nov 16, 2023",
    time: "8:15 (ET)",
    home: "Baltimore Ravens",
    away: "Cincinnati Bengals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BAL",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CIN",
  },
  {
    id: 154,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Carolina Panthers",
    away: "Dallas Cowboys",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/DAL",
  },
  {
    id: 155,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Cleveland Browns",
    away: "Pittsburgh Steelers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/CLE",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PIT",
  },
  {
    id: 156,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Detroit Lions",
    away: "Chicago Bears",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DET",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/CHI",
  },
  {
    id: 157,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Green Bay Packers",
    away: "Los Angeles Chargers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/GB",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAC",
  },
  {
    id: 158,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Houston Texans",
    away: "Arizona Cardinals",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/HOU",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/ARI",
  },
  {
    id: 159,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Jacksonville Jaguars",
    away: "Tennessee Titans",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/JAX",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TEN",
  },
  {
    id: 160,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Miami Dolphins",
    away: "Las Vegas Raiders",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIA",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/LV",
  },
  {
    id: 161,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "1:00 (ET)",
    home: "Washington Commanders",
    away: "New York Giants",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/WAS",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYG",
  },
  {
    id: 162,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "4:05 (ET)",
    home: "San Francisco 49ers",
    away: "Tampa Bay Buccaneers",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/SF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/TB",
  },
  {
    id: 163,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "4:05 (ET)",
    home: "Buffalo Bills",
    away: "New York Jets",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/BUF",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/NYJ",
  },
  {
    id: 164,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "4:25 (ET)",
    home: "Los Angeles Rams",
    away: "Seattle Seahawks",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/LAR",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/SEA",
  },
  {
    id: 165,
    week: 11,
    date: "Sun, Nov 19, 2023",
    time: "4:25 (ET)",
    home: "Denver Broncos",
    away: "Minnesota Vikings",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/DEN",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/MIN",
  },
  {
    id: 166,
    week: 11,
    date: "Mon, Nov 20, 2023",
    time: "8:15 (ET)",
    home: "Kansas City Chiefs",
    away: "Philadelphia Eagles",
    home_logo: "https://static.www.nfl.com/league/api/clubs/logos/KC",
    away_logo: "https://static.www.nfl.com/league/api/clubs/logos/PHI",
  },
];
